import apiRoutes from './api.routes';
import ModelService from './model.service';
import api from './api.service';

const VoteService = new ModelService(apiRoutes.vote, '/vote');

VoteService.addVote = params => api.catchError(async () => {
  const { data } = await api.post(apiRoutes.vote, params);
  return data;
});

export default VoteService;



// WEBPACK FOOTER //
// ./src/services/vote.service.js